import { Menu, MenuItem, Stack, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Dialog from '../../../../../components/Dialog/Dialog';
import { RootState } from '../../../../../reduxService';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { putMacro1ProjectAsync, putMacro2ProjectAsync } from '../../../../api/store/BeMaccaferriStoreHelper';
import { projectToData as m1PtD } from '../../../../Macro1/store/project/projectslice';
import { projectToData as m2PtD } from '../../../../Macro2/store/project/projectslice';
import { selectMacro1, selectMacro2, selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { ISaveButtonProps } from './ISaveButton';
import './SaveButton.scss';

const saveFile = (filename: string, fileContent: string) => {
    let bb = new Blob([fileContent], { type: 'text/plain' });
    let a = document.createElement('a');
    a.download = filename + '.macro';
    a.href = window.URL.createObjectURL(bb);
    a.click();
};

const SaveButton = (props: ISaveButtonProps) => {
    const { t } = useTranslation();

    const [loading, setLoading] = React.useState<boolean>(false);
    const [ErrorDialog, setErrorDialog] = React.useState<string>('');
    const closeErrorDialog = () => {
        setErrorDialog('');
    };
    const [projectType, setProjectType] = React.useState<string>('');
    const projectInfo = useAppSelector(selectProjectInfo);

    const macro1 = useAppSelector(selectMacro1);
    const macro2 = useAppSelector(selectMacro2);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const currentProjectM1 = useSelector((state: RootState) => {
        if (window.location.href.includes('Macro1')) {
            if (projectType !== 'macro1') setProjectType('macro1');
            return { ...state.Macro1.project.data };
        }
        return undefined;
    });

    const currentProjectM2 = useSelector((state: RootState) => {
        if (window.location.href.includes('Macro2')) {
            if (projectType !== 'macro2') setProjectType('macro2');
            return { ...state.Macro2.project.data };
        }
        return undefined;
    });

    const handleSaveCloud = async () => {
        setLoading(true);
        try {
            if (currentProjectM1) {
                await putMacro1ProjectAsync(m1PtD(currentProjectM1));
            } else if (currentProjectM2) {
                await putMacro2ProjectAsync(m2PtD(currentProjectM2));
            }
        } catch (ex) {
            setErrorDialog(((ex as any)?.response?.data?.PropertiesNotValid ?? '' + t('errors.projectCommit.unspecific_error')).replaceAll(', ', '\n'));
        }
        setLoading(false);
    };

    const handleSaveFile = async () => {
        saveFile(projectInfo.data!.projectName, JSON.stringify({ projectInfo, macro1, macro2 }));
    };

    return (
        <>
            <button type='button' className={props.className} onClick={handleOpenMenu}>
                {<i className='fa-solid fa-floppy-disk' />}
                {t('header_save_button')}
                <i className='fa-solid fa-angle-down' />
            </button>
            <Menu
                id='save-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                MenuListProps={{
                    'aria-labelledby': 'save-button',
                }}>
                <MenuItem disabled={loading} onClick={handleSaveCloud}>
                    <Stack direction={'row'} gap={1} alignItems={'center'}>
                        <Typography>{t('header_save_button_cloud')}</Typography>
                        {loading && <CircularProgress className='menu-spinner' />}
                    </Stack>
                </MenuItem>
                <MenuItem onClick={handleSaveFile}>
                    <Stack direction={'row'} gap={1} alignItems={'center'}>
                        <Typography>{t('header_save_button_file')}</Typography>
                    </Stack>
                </MenuItem>
            </Menu>
            <Dialog open={!!ErrorDialog && ErrorDialog.length > 0} title={`${t('errors.generic.title')}`} onClose={closeErrorDialog}>
                <div>{ErrorDialog}</div>
            </Dialog>
        </>
    );
};

export default SaveButton;
